import { useTranslation } from 'react-i18next';
import { QSpinner, QText } from '@qualio/ui-components';
import { RootCause } from '../../../types';
import ItemWithIdAndNameLabel from './ItemWithIdAndNameLabel';
import { CodeWithNameTooltip } from './ItemWithCodeAndNameLabel';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

const ActiveRootCauseFilter = ({
  value,
  rootCausesMap,
  isMultiSelect = false,
  isMultiSelectEventsListEnabled = false,
}: {
  value: unknown;
  rootCausesMap: Record<string, RootCause>;
  isMultiSelect?: boolean;
  isMultiSelectEventsListEnabled?: boolean;
}) => {
  const { t } = useTranslation();
  if (value === EMPTY_FILTER_VALUE) {
    return <QText as="span">{t('common.labels.emptyRootCauses')}</QText>;
  }
  const id = value as string;
  const rootCause = rootCausesMap[id];
  if (rootCause) {
    if (isMultiSelectEventsListEnabled) {
      return <CodeWithNameTooltip code={rootCause.displayId} name={rootCause.name} />;
    }
    if (isMultiSelect) {
      return (
        <QText as="span">
          {rootCause.displayId} - {rootCause.name}
        </QText>
      );
    }
    return <ItemWithIdAndNameLabel itemName={rootCause.name} itemId={rootCause.displayId} setMinWidth={false} />;
  }
  return <QSpinner size="sm" />;
};

export default ActiveRootCauseFilter;
